import { useCallback } from 'react';
import { useReactFlow } from '@xyflow/react';
import useAutomationsStore from '../../../../store/useAutomationsStore';
import { getInitialNodeData } from '../constants/nodeDefaults';

export default function useNodeDrag() {
  const { screenToFlowPosition } = useReactFlow();
  const { addNode } = useAutomationsStore();

  const onDragOver = useCallback((e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }, []);

  const onDrop = useCallback(
    (e) => {
      e.preventDefault();

      const type = e.dataTransfer.getData('application/reactflow-type');
      const nodeType = e.dataTransfer.getData('application/reactflow-nodeType');
      const label = e.dataTransfer.getData('application/reactflow-label');
      const description = e.dataTransfer.getData('application/reactflow-description');
      const image = e.dataTransfer.getData('application/reactflow-image');

      if (!type || !nodeType) return;

      const position = screenToFlowPosition({ x: e.clientX, y: e.clientY });

      addNode({
        type,
        position,
        data: {
          label,
          nodeType,
          description,
          ...(image ? { image } : {}),
          ...getInitialNodeData(nodeType),
        },
      });
    },
    [screenToFlowPosition, addNode]
  );

  return { onDragOver, onDrop };
}
